
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.69593 4.075C8.32593 5.135 8.14593 6.235 8.15593 7.365C8.17593 12.645 12.5359 17.115 17.8759 17.335C18.0259 17.335 18.1659 17.335 18.3159 17.335C18.6759 17.335 19.0459 17.315 19.4059 17.275C17.7559 19.175 15.3159 20.295 12.7459 20.295C12.6159 20.295 12.4759 20.295 12.3459 20.295C7.97593 20.105 4.32593 16.595 4.02593 12.315C3.77593 8.885 5.63593 5.655 8.69593 4.075ZM9.61593 1.695C9.24593 1.695 8.86593 1.805 8.53593 1.935C4.47593 3.655 1.68593 7.745 2.02593 12.455C2.39593 17.765 6.88593 22.055 12.2559 22.295C12.4159 22.295 12.5759 22.305 12.7459 22.305C16.3259 22.305 19.5159 20.575 21.4659 17.915C21.6959 17.595 21.8759 17.265 21.9559 16.925C22.0359 16.585 22.0259 16.185 21.8159 15.835C21.5959 15.485 21.2559 15.295 20.9059 15.215C20.7459 15.175 20.5759 15.165 20.3959 15.165C20.1959 15.165 19.9959 15.185 19.7959 15.225C19.3159 15.315 18.8359 15.355 18.3259 15.355C18.2059 15.355 18.0859 15.355 17.9659 15.355C13.6759 15.175 10.1759 11.585 10.1559 7.375C10.1559 6.235 10.3859 5.165 10.8059 4.185C11.0859 3.535 11.2359 2.665 10.6259 2.095C10.3359 1.795 9.97593 1.695 9.61593 1.695Z","fill":"#16171F"}})])
          )
        }
      }
    